window.$a_jQuery(function($) {
        
    // Инициализация Isotope
    var $grid = $('.blog__article-list').isotope({
        itemSelector: '.blog__article-item',
        layoutMode: 'fitRows',
          fitRows: {
            gutter: 40 // отступ между элементами в px
          }
    });

    // Объект для хранения выбранных фильтров по группам
    var filters = {};

    // Обработчик клика по кнопкам фильтров
    $('.js-radio-button-group .button').on('click', function() {
        var $btn = $(this);
        var filterGroup = $btn.closest('.js-radio-button-group').attr('data-filter-group');
        var filterValue = $btn.attr('data-filter');

        // Обновляем активный класс кнопок в группе
        $btn.siblings().removeClass('is-checked');
        $btn.addClass('is-checked');

        // Обновляем состояние фильтров
        filters[filterGroup] = filterValue;

        // Формируем комбинированный селектор фильтрации
        var comboFilter = combineFilters(filters);

        // Применяем фильтр
        $grid.isotope({ filter: comboFilter });
    });

    // Функция объединения фильтров из разных групп
    function combineFilters(filters) {
        var allFilters = [];
        for (var key in filters) {
            if (filters[key] && filters[key] !== '') {
                allFilters.push(filters[key]);
            }
        }
        // Если фильтров нет, показываем все
        return allFilters.length ? allFilters.join('') : '*';
    }

    // Изначально активируем фильтр "any" для всех групп (если нужно)
    $('.js-radio-button-group').each(function() {
        $(this).find('.button.is-checked').trigger('click');
    });
});